'use client';
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import MediaBox from "@/components/media/MediaBox";
import { useSearchParams } from "next/navigation";
import { getMediaList } from "@/api";

const MyComponent = ({ data }) => {
    const searchParams = useSearchParams();
    const [keyword, setKeyword] = useState(data);
    const keywordParam = searchParams.get("status");

    useEffect(() => {
        const fetchData = async () => {

            if (keywordParam) {
                try {
                    const getApi = await getMediaList(keywordParam);
                    setKeyword(getApi?.media || []); // Fallback to an empty array if data is undefined
                } catch (e) {
                    console.error(e); // Log any errors
                }
            }
        };

        fetchData();
    }, [searchParams]); // Only run when searchParams change


    return (
        (<StyledComponent className={'pt-120 pb-120'}>
            <Container>
                <Row>
                    {keyword && keyword.length > 0 ? (
                        keyword.map((e, index) => (
                            <Col key={index} sm={4}>
                                <MediaBox
                                    title={e?.post_title}
                                    img={e?.thumb}
                                    date={e?.date}
                                    type={e?.type}
                                    keyword={keywordParam}
                                    src={e?.post_name}
                                />
                            </Col>
                        ))
                    ) : (
                        (<p>No media found</p>) // Add a fallback UI
                    )}
                </Row>
                {/* Uncomment and modify the button as needed */}
                {/* <Row className={'justify-content-center align-items-center'}>
                    <div>
                        <Button text={'Load More'} border={`1px`} borderColor={`${text}`} color={`${text}`} hoverBackground={`${hover}`} />
                    </div>
                </Row> */}
            </Container>
        </StyledComponent>)
    );
};

const StyledComponent = styled.section`
    background-color: #F9F9F9;
    .col-sm-4 {
        margin-bottom: 30px;
    }
`;

export default MyComponent;
